var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.rubberBand.active),expression:"rubberBand.active"}],staticClass:"absolute bg-blue-400/20",style:(_vm.boxStyles)})}
var staticRenderFns = []

export { render, staticRenderFns }